module.exports = __webpack_public_path__ + "static/img/reseveration.f04c1dc0.png";